export const avatarData = {
  altText: 'Person avatar',
} as const;
